import { IntegrationType } from 'routes/Integrations/helpers/types'
import { Connector, ConnectorSpec } from '@integration-app/sdk'
import { INTEGRATIONS_REVALIDATE_TIME, LINKS } from 'routes/constants'
import {
  fetchIntegration,
  fetchIntegrationGettingStarted,
} from 'routes/Integrations/helpers'
import { fetchConnector } from 'routes/Integrations/helpers/connectors'
import {
  getHeadersFromMarkdown,
  normalizeHeaders,
} from 'routes/components/Shared'
import IntegrationOverviewPage from 'routes/Integrations/Integration/Overview'

export default function IntegrationOverview({
  integration,
  gettingStartedToc,
  connector,
  similarConnectors,
}: {
  integration: IntegrationType
  gettingStartedToc?: string
  connector: Connector
  similarConnectors: Array<ConnectorSpec>
}) {
  return (
    <IntegrationOverviewPage
      integration={integration}
      gettingStartedToc={gettingStartedToc}
      connector={connector}
      similarConnectors={similarConnectors}
    />
  )
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  }
}

export async function getStaticProps({ params }) {
  // Fetch data from external API
  const integrationKey = params.integrationKey

  try {
    const integration = await fetchIntegration(integrationKey)

    const connectorData = await fetchConnector(integrationKey)

    let headersOnlyText = ''

    if (integration.hasReadme) {
      const readme = await fetchIntegrationGettingStarted(integrationKey)
      headersOnlyText = normalizeHeaders(getHeadersFromMarkdown(readme))
    }

    // Pass data to the page via props
    return {
      props: {
        integration,
        gettingStartedToc: headersOnlyText,
        ...connectorData,
      },
      revalidate: INTEGRATIONS_REVALIDATE_TIME, // In seconds
    }
  } catch (e) {
    console.error(e)
    // `redirect` can not be returned from getStaticProps during pre-rendering
    // During pre-rendering we can only return `notFound`
    if (process.env.npm_lifecycle_event === 'build') {
      return {
        notFound: true,
      }
    }
    return {
      redirect: {
        destination: LINKS.INTEGRATIONS,
        permanent: false,
      },
    }
  }
}
